module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded"
  }, [_vm._v("To"), _c('br'), _vm._v("Lieutenant (“Leftenant”) Commander Julie Vitali, Royal Navy,"), _c('br'), _vm._v("who would’ve made one hell of a pirate,"), _c('br'), _vm._v("and who wrote the book on Yankees."), _c('br'), _c('br'), _vm._v("For S, as always")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59c36493","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ded.vue
// module id = 66
// module chunks = 0